'use client';

import React, { JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { formatPrice } from '@/utils/formatting';
import { getStoreLanguage } from '@/utils/language';

import type { TotalsRow, TotalsRowKey } from './totalsRows';

import styles from './_styles/Totals.module.scss';


// Prop types
interface TotalsTableProps {
	rows: TotalsRow[];
	adminTheme?: boolean;
	className?: string;
	slot?: ReactNode;
	slotAfterKey?: TotalsRowKey;
}


export const TotalsTable = (props: TotalsTableProps): JSX.Element => {

	// Props
	const {
		rows,
		adminTheme,
		className,
		slot,
		slotAfterKey,
	} = props;

	// Internationalization
	const {
		i18n,
		t,
	} = useTranslation();

	const storeLang = getStoreLanguage(i18n);

	// Render
	return (
		<div className={`${styles.Totals} ${adminTheme ? styles.adminTheme : ''} ${className || ''}`}>
			{rows.map((row) => (
				<React.Fragment key={row.key}>
					<div className={`${styles.row} ${row.kind === 'total' ? styles.total : ''}`}>
						<div className={styles.label}>{t(row.label)}</div>
						<div
							className={styles.value}
							dangerouslySetInnerHTML={{
								__html: formatPrice(row.amount, {
									addTags: true,
									language: storeLang,
								}),
							}} />
					</div>
					{row.key === slotAfterKey && slot}
				</React.Fragment>
			))}
		</div>
	);
};

export default TotalsTable;
